import { useState } from "react";
import { View, LayoutChangeEvent, LayoutAnimation, UIManager, Platform } from "react-native";
import { Text } from "react-native-paper";
import { LinkButton } from "../../components";
import { Feather } from "@expo/vector-icons";
import { LinearGradient } from "expo-linear-gradient";
import HTMLDisplay from "../../components/HTMLDisplay";

if (Platform.OS === "android" && UIManager.setLayoutAnimationEnabledExperimental) {
  UIManager.setLayoutAnimationEnabledExperimental(true);
}

export interface ContentSectionProps {
  title: string;
  content: string;
}

const ContentSection = ({ title, content }: ContentSectionProps) => {
  const [containerHeight, setContainerHeight] = useState<number>(0);
  const [contentHeight, setContentHeight] = useState<number>(0);

  const handleLayout = (setHeight: React.Dispatch<React.SetStateAction<number>>) => (event: LayoutChangeEvent) => {
    const { height } = event.nativeEvent.layout;
    setHeight((prevHeight) => (prevHeight ? prevHeight : height));
  };

  const [showMore, setShowMore] = useState(false);

  const handleShowMore = () => {
    LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
    setShowMore((prev) => !prev);
  };

  const hasHiddenContent = contentHeight > containerHeight;

  return (
    <View className="flex border-t border-sky-light px-6 py-8">
      <Text className="mb-4 text-title-5 font-700 text-ink-darkest">{title}</Text>
      <View className={`${showMore ? "" : "max-h-72"} overflow-scroll`} onLayout={handleLayout(setContainerHeight)}>
        <View onLayout={handleLayout(setContentHeight)}>
          <HTMLDisplay html={content} />
        </View>
        {!showMore && hasHiddenContent && (
          <LinearGradient
            colors={["rgba(255,255,255,0)", "rgba(255,255,255,1)"]}
            locations={[0.8, 1]}
            className="absolute w-full h-72"
          />
        )}
      </View>
      <View className="mt-4 items-start">
        {hasHiddenContent && (
          <LinkButton onPress={handleShowMore}>
            Show {showMore ? "Less " : "More "}
            <Feather name={showMore ? "chevron-up" : "chevron-down"} size={12} />
          </LinkButton>
        )}
      </View>
    </View>
  );
};

export default ContentSection;
